export const sendIcon = require("../assets/send_icon.svg");
export const replyIcon = require("../assets/reply_icon.svg");
export const replyIconLight = require("../assets/reply_icon_light.svg");
export const closeModalIcon = require("../assets/closeIcon.svg");
export const closeLightIcon = require("../assets/close_light_icon.svg");
